import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { Intent } from '~/infra/access-control';
import { DraftModel } from '~/models/DraftModel';
import { RelationshipStatus } from '~/models/relationship';
export const studioProposalActions = (param)=>{
    let { proposal, relationshipId, draftId, proposalActions, texts, onWithdraw } = param;
    return {
        duplicate: proposalActions.getDuplicateProposalAction(proposal.id, {
            isSampleProposal: proposal.isSample,
            draftId: proposal.draftId
        }),
        copyLink: proposalActions.getCopyProposalLinkAction(proposal),
        sendReminder: proposalActions.getSendProposalReminderAction(proposal.id, proposal.isSample),
        edit: proposalActions.getEditProposalAction(proposal, 'viewProposal'),
        cancel: {
            text: texts.withdraw(),
            intent: Intent.CancelProposal,
            disabled: false,
            onClick: ()=>onWithdraw({
                    relationshipId,
                    draftId
                })
        }
    };
};
export const viewProposalModeOf = (param)=>{
    let { relationship, proposal, proposalActions, texts, onWithdraw } = param;
    return _object_spread({
        proposalAsDraft: DraftModel.fromRelationship(relationship),
        isExpiredProposal: relationship.status === RelationshipStatus.Expired
    }, studioProposalActions({
        proposal,
        relationshipId: relationship.id,
        draftId: relationship.draftId,
        proposalActions,
        texts,
        onWithdraw
    }));
};
